"use client";

import { useInView } from "framer-motion";
import { useRef } from "react";
import { AboutHeader } from "./AboutHeader";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export function AboutGsdental() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  return (
    <article ref={ref} className="relative py-8 overflow-hidden ">
      {/* Header Section */}
      <AboutHeader
        containerVariants={containerVariants}
        itemVariants={itemVariants}
        isInView={isInView}
      />
    </article>
  );
}
